import { h } from 'ui/Framework';

export default function render() {
  return h(
    'div',
    {
      dataTestId: 'loader'
    },
    []
  );
}



// WEBPACK FOOTER //
// ./src/javascripts/app/ContentList/Search/Loader.es6.js